import { createSlice } from "@reduxjs/toolkit";
import i18nInit from "../../i18nInit";
import { getMeRequestSuccess } from "../authentication/authSlice";

interface i18nState {
	locale: "eu" | "us";
}

const initialState: i18nState = {
	locale: "eu"
};

export const i18nSlice = createSlice({
	name: "i18n",
	initialState,
	reducers: {
		setLocale: (state, action) => {
			state.locale = action.payload;
			i18nInit.changeLanguage(state.locale);
		},
	},
	extraReducers: (builder) => {	
		builder
      		.addCase(getMeRequestSuccess, (state, action) => {
				const savedLocale = localStorage.getItem("gepo_locale");
				if (savedLocale) {
					state.locale = savedLocale as "eu" | "us";
				} else {
					state.locale = action.payload.groups.includes("res-country-us") ? "us" : "eu";
				}
				i18nInit.changeLanguage(state.locale);
		    })
	}
});

export const { setLocale } = i18nSlice.actions;

export default i18nSlice.reducer;
